// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"523":"shop","818":"auth","929":"terms","981":"rules"}[chunkId] + "." + {"523":"644339ab","818":"aa03d8d2","929":"a1d53f2a","981":"20a31e29"}[chunkId] + ".js";
};